import React from "react";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
import JssProvider from 'react-jss/lib/JssProvider';
import { createGenerateClassName } from '@material-ui/core/styles';

// components
import Layout from "./Layout";

// pages
import Error from "../pages/error";
import Login from "../pages/login";
import Cookies from 'universal-cookie';
import checkToken from "../services/checkToken";
import LayoutTecnico from "./LayoutTecnico/LayoutTecnico";
import LayoutMagazzino from "./LayoutMagazzino/LayoutMagazzino";
import LayoutCommerciale from "./LayoutCommerciale/LayoutCommerciale";
import LayoutCustomerService from "./LayoutCustomerService/LayoutCustomerService";

const generateClassName = createGenerateClassName({
  dangerouslyUseGlobalCSS: true, // won't minify CSS classnames when true
  productionPrefix: 'c', // 'jss' by default
});

var isAuthenticated;

export default class App extends React.Component{
  
  constructor() {
    super();
    this.state = {
      isAuth: false,
    };
  }

  async componentDidMount() {
    this.setState({isLoading: true})
    const cookies = new Cookies();
    var token = cookies.get('token', { path: '/' });
    var uname = cookies.get('username', { path: '/' });
    isAuthenticated = await checkToken(uname, token);
    this.setState({isLoading: false, isAuth: isAuthenticated })

    if (window.location.href.split('/').length === 5) {
      window.location.href = '/#/login';
    }
  }

  render(){

    if (this.state.isLoading === true){
      return <div />;
    }

    return (
      <JssProvider generateClassName={ generateClassName }>
      <HashRouter>
        <Switch>
          <Route path="/app" component={Layout} />
          <Route path="/tecnico" component={LayoutTecnico} />
          <Route path="/magazzino" component={LayoutMagazzino} />
          <Route path="/commerciale" component={LayoutCommerciale} />
          <Route path="/service" component={LayoutCustomerService} />
          <Route path="/login" component={Login} />
          <Route component={Error} />
        </Switch>
      </HashRouter>
      </JssProvider>
    );
    }
  }

  // #######################################################################


  function PrivateRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated ? (
            React.createElement(component, props)
          ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: {
                  from: props.location,
                },
              }}
            />
          )
        }
      />
    );
  }

  function PublicRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated ? (
            <Redirect
              to={{
                pathname: "/",
              }}
            />
          ) : (
            React.createElement(component, props)
          )
        }
      />
    );
  }

